import "./namespace.js";
import "#/legacy/namespaces.js";

DoctorFinder.Helpers.recentLimit = 5; // Cap the number of recent searches, after which the oldest search will be removed when a new one is added

DoctorFinder.Helpers.resetRecentSearches = (namespace) => DoctorFinder.Helpers.persistRecentStorage(namespace, []);

DoctorFinder.Helpers.recordRecentSearch = (namespace, description, filters) => {
  let storage = DoctorFinder.Helpers.loadRecent(namespace);
  storage = storage.filter((item) => !(item.text === description && item.type === "search"));
  storage.unshift({ text: description, filters, type: "search" });
  storage = storage.slice(0, DoctorFinder.Helpers.recentLimit);

  return DoctorFinder.Helpers.persistRecentStorage(storage);
};

DoctorFinder.Helpers.recordRecentDoctor = (namespace, name, doctorUrl, imageUrl) => {
  let storage = DoctorFinder.Helpers.loadRecent(namespace);
  storage = storage.filter((item) => !(item.url === doctorUrl && item.type === "doctor"));
  storage.unshift({ text: name, url: doctorUrl, type: "doctor", icon: imageUrl });
  storage = storage.slice(0, DoctorFinder.Helpers.recentLimit);

  return DoctorFinder.Helpers.persistRecentStorage(namespace, storage);
};

DoctorFinder.Helpers.loadRecent = (namespace) =>
  JSON.parse(localStorage.getItem(`recent_${namespace}_doctor_searches`) || "[]");

DoctorFinder.Helpers.persistRecentStorage = (namespace, storage) =>
  localStorage.setItem(`recent_${namespace}_doctor_searches`, JSON.stringify(storage));
